import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { PreferencesContext } from '@common/contexts/preferences';
import KeyboardInput from '@common/components/InputKeyboard';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const KeyboardFormField = ({
  name, value, onChange, readOnly, errorMessage, type, disabled,
}) => {
  const t = useTranslation();
  const [{ lang }] = useContext(PreferencesContext);
  const [active, setActive] = useState(type);

  const passwordType = active ? type : 'text';

  return (
    <>
      <div className="popup-txt">{t(name)}</div>
      <div className="input-row">
        <KeyboardInput
          readOnly={readOnly}
          disableSearchIcon
          onChange={onChange}
          value={value || ''}
          lang={lang}
          class="popup-inp"
          type={passwordType}
          disabled={disabled}
        />
        {type === 'password' && (
          <i
            onClick={() => setActive(!active)}
            className={`password-view-icon ${active ? 'icon-eye-hide' : 'icon-eye-show'
              }`}
          />
        )}
      </div>

      {!!errorMessage && <div className="error-message">{t(errorMessage)}</div>}
    </>
  );
};

KeyboardFormField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
  readOnly: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

export default KeyboardFormField;
